import React from 'react'
import {Icon} from '@chakra-ui/react'

const LockIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M18 8V6C18 2.69 15.31 0 12 0C8.69 0 6 2.69 6 6V8H3V24H21V8H18ZM8 6C8 3.79 9.79 2 12 2C14.21 2 16 3.79 16 6V8H8V6ZM19 22H5V10H19V22Z"
                fill="currentColor"
            />
            <path d="M13 13H11V19H13V13Z" fill="currentColor" />
        </Icon>
    )
}

export default LockIcon
